//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";
import type { OverviewObject } from "./types";
import { Attribute } from "./Attribute";
import { ObjectTypeBadge } from "./ObjectTypeBadge";
import { Badge } from "./primitives";

export interface ObjectGalleryProps extends HTMLAttributes<HTMLDivElement> {
  items?: OverviewObject[];
  onOpen?: (item: OverviewObject) => void;
  showAttributes?: number;
  emptyMedia?: ReactNode;
}

/** Gallery representation: image-forward tiles. */
export function ObjectGallery({
  items = [],
  onOpen,
  showAttributes = 2,
  emptyMedia,
  className = "",
  ...rest
}: ObjectGalleryProps) {
  return (
    <div className={`bui-ov-gallery ${className}`} {...rest}>
      {items.map((item) => (
        <article
          key={item.id}
          onClick={() => onOpen?.(item)}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            cursor: onOpen ? "pointer" : "default",
          }}
        >
          <div className="bui-ov-gallery__media">
            {item.image ??
              emptyMedia ?? (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4.5" width="18" height="15" rx="2" />
                  <circle cx="8.5" cy="10" r="1.5" />
                  <path d="m3.5 17 5-4.5 4 3.5 3-2.5 5 4" />
                </svg>
              )}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <ObjectTypeBadge
                type={item.type}
                identifier={item.identifier}
                color={item.typeColor ?? "brand"}
              />
              {item.status && (
                <span style={{ marginLeft: "auto", flexShrink: 0 }}>
                  <Badge color={item.statusColor} dot>
                    {item.status}
                  </Badge>
                </span>
              )}
            </div>
            <h3
              style={{
                font: "var(--t-paragraph-m)",
                fontWeight: 600,
                color: "var(--text-primary)",
                margin: 0,
                textWrap: "pretty",
              }}
            >
              {item.title}
            </h3>
            {item.subtitle && (
              <p
                style={{
                  font: "var(--t-paragraph-s)",
                  color: "var(--text-tertiary)",
                  margin: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {item.subtitle}
              </p>
            )}
            {showAttributes > 0 && (item.attributes?.length ?? 0) > 0 && (
              <div style={{ display: "flex", gap: 20, marginTop: 4 }}>
                {(item.attributes ?? []).slice(0, showAttributes).map((a) => (
                  <Attribute key={a.label} label={a.label} value={a.value} />
                ))}
              </div>
            )}
          </div>
        </article>
      ))}
    </div>
  );
}
